<template>
	<div class="card border-0 card-with-shadow">
		<div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
			<h5 v-show="isDetailsActive" class="card-title text-muted mb-0">{{ $t('invert_details') }}</h5>
			<h5 v-show="!isDetailsActive" class="card-title text-muted mb-0">{{ $t('invert_edit_details') }}</h5>

			<div>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoClose">
					<app-icon name="x-square" stroke-width="1"/>
				</a>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoSync">
					<app-icon name="check-square" stroke-width="1"/>
				</a>
				<a v-show="isDetailsActive && !blockEdit" class="text-muted" href="#" @click.prevent="detailsInfoEdit">
					<app-icon name="edit" stroke-width="1"/>
				</a>
			</div>

		</div>
		<div class="card-body">

			<div v-show="isDetailsActive">
			
				
				<div class="form-group mb-3">
					<div class="form-row">
						<a href="#" class="col-1 text-primary align-items-left" @click="openModal('info_text_title_inv', 'info_text_body_inv')">
							<app-icon  name="alert-circle" width="20" height="20" />
						</a>
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('inv') }}
						</label>
						<div class="col-6">
								<span v-for="item in invList" v-if="item.id == detailsData.inv_id">
      								{{ item.name }}
    							</span>
						</div>
					</div>
				</div>
				
				<div class="form-group mb-3">
					<div class="form-row">
						<a href="#" class="col-1 text-primary align-items-left" @click="openModal('info_text_title_storage', 'info_text_body_storage')">
							<app-icon  name="alert-circle" width="20" height="20" />
						</a>
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('storage') }}
						</label>
						<div class="col-6">
								<span v-for="item in storageList" v-if="item.id == detailsData.inrest_id">
      								{{ item.name }}
    							</span>
						</div>
					</div>
				</div>
				
				
				
				
				<template>
				<div class="form-group mb-3">
					<div class="form-row">
						<a href="#" class="col-1 text-primary align-items-left" @click="openModal('info_text_title_where_store', 'info_text_body_where_store')">
							<app-icon  name="alert-circle" width="20" height="20" />
						</a>
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('where_store') }}
						</label>
						<div class="col-6">
							
							<template v-if="detailsData.inrest_id == 2 ">
								<span v-for="item in organizationList" v-if="item.id == detailsData.org">
      								<a :href="'/crm/organizations/' + item.id + '/edit'" target="_blank">{{ item.name }}</a>
    							</span>
							</template>
							<template v-if="detailsData.inrest_id == 3 ">
								<span v-for="item in peopleList" v-if="item.id == detailsData.who">
      								<a :href="'/crm/persons/' + item.id + '/edit'" target="_blank">{{ item.name }}</a>
    							</span>
							</template>
							<template v-else>
								
									<span v-for="item in zalList" v-if="item.id == detailsData.zal_id">
      									{{ item.name }}
    								</span>
								
							</template>
						</div>
					</div>
				</div>
				</template>
				
				<div class="form-group mb-3">
					<div class="form-row">
						<a href="#" class="col-1 text-primary align-items-left" @click="openModal('info_text_title_desc_id', 'info_text_body_desc_id')">
							<app-icon  name="alert-circle" width="20" height="20" />
						</a>
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('desc_id') }}
						</label>
						<div class="col-6">
								<span v-for="item in yesnoList" v-if="item.id == detailsData.desc_id">
      								{{ item.name }}
    							</span>
						</div>
					</div>
				</div>
			
				<div class="form-group mb-3">
					<div class="form-row">
						<a href="#" class="col-1 text-primary align-items-left" @click="openModal('info_text_title_tago_id', 'info_text_body_tago_id')">
							<app-icon  name="alert-circle" width="20" height="20" />
						</a>
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('tago_id') }}
						</label>
						<div class="col-6">
								<span v-for="item in yesnoList" v-if="item.id == detailsData.tago_id">
      								{{ item.name }}
    							</span>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<a href="#" class="col-1 text-primary align-items-left" @click="openModal('info_text_title_photo_id', 'info_text_body_photo_id')">
							<app-icon  name="alert-circle" width="20" height="20" />
						</a>
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('photo_id') }}
						</label>
						<div class="col-6">
								<span v-for="item in yesnoList" v-if="item.id == detailsData.photo_id">
      								{{ item.name }}
    							</span>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<a href="#" class="col-1 text-primary align-items-left" @click="openModal('info_text_title_fulltext_id', 'info_text_body_fulltext_id')">
							<app-icon  name="alert-circle" width="20" height="20" />
						</a>
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('fulltext_id') }}
						</label>
						<div class="col-6">
								<span v-for="item in yesnoList" v-if="item.id == detailsData.fulltext_id">
      								{{ item.name }}
    							</span>
						</div>
					</div>
				</div>
				
				<div class="form-group mb-3">
					<div class="form-row">
						<a href="#" class="col-1 text-primary align-items-left" @click="openModal('info_text_title_table_id', 'info_text_body_table_id')">
							<app-icon  name="alert-circle" width="20" height="20" />
						</a>
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('table_id') }}
						</label>
						<div class="col-6">
								<span v-for="item in yesnoList" v-if="item.id == detailsData.table_id">
      								{{ item.name }}
    							</span>
						</div>
					</div>
				</div>
			
				<div class="form-group mb-3">
					<div class="form-row">
						<a href="#" class="col-1 text-primary align-items-left" @click="openModal('info_text_title_science', 'info_text_body_science')">
							<app-icon  name="alert-circle" width="20" height="20" />
						</a>
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('science') }}
						</label>
						<div class="col-6">
								<span v-for="item in yesnoList" v-if="(item.id == detailsData.science)">
      								{{ item.name }}
    							</span>
						</div>
					</div>
				</div>
				
				<div class="form-group mb-2">
					<div class="form-row">
						<a href="#" class="col-1 text-primary align-items-left" @click="openModal('info_text_title_restorer_id', 'info_text_body_restorer_id')">
							<app-icon  name="alert-circle" width="20" height="20" />
						</a>
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('restorer_id') }}
						</label>
						<div class="col-6">
								<span v-for="item in restorerList" v-if="item.id == detailsData.restorer_id">
      								{{ item.name }}
    							</span>
						</div>
					</div>
				</div>


							
			</div>

			<div v-show="!isDetailsActive">
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('inv') }}</label>
						<div class="col-7">
							
							<app-input v-model="detailsData.inv_id"
							           :error-message="$errorMessage(errors, 'inv_id')"
							           :list="invList"
							           list-value-field='name'
							           type="select"/>
						</div>

					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('storage') }}</label>
						<div class="col-7">
							
							<app-input v-model="detailsData.inrest_id"
							           :error-message="$errorMessage(errors, 'inrest_id')"
							           :list="storageList"
							           list-value-field='name'
							           type="select"/>
						</div>

					</div>
				</div>
				<template>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('zal_name') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.zal_id"
							           :error-message="$errorMessage(errors, 'zal_id')"
							           :list="zalList"
							           list-value-field='name'
							           type="select"/>
						</div>
					</div>
				</div>

				</template>
				<template>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('organization') }}</label>
						<div class="col-7">
						
							<app-input v-model="detailsData.org"
							           :error-message="$errorMessage(errors, 'org')"
							           :list="organizationList"
							           list-value-field='name'
										    :placeholder="$t('choose_org')"
							           type="search-select"/>
						</div>

					</div>
				</div>
				</template>
				<template>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('contact') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.who"
							           :error-message="$errorMessage(errors, 'who')"
							           :list="peopleList"
							           list-value-field='name'
										    :placeholder="$t('choose_who')"
							           type="search-select"/>
						</div>

					</div>
				</div>
				</template>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('desc_id') }}</label>
						<div class="col-7">
							
							<app-input v-model="detailsData.desc_id"
							           :error-message="$errorMessage(errors, 'desc_id')"
							           :list="yesnoList"
							           list-value-field='name'
							           type="select"/>
						</div>

					</div>
				</div>
				
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('tago_id') }}</label>
						<div class="col-7">
							
							<app-input v-model="detailsData.tago_id"
							           :error-message="$errorMessage(errors, 'tago_id')"
							           :list="yesnoList"
							           list-value-field='name'
							           type="select"/>
						</div>

					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('photo_id') }}</label>
						<div class="col-7">
							
							<app-input v-model="detailsData.photo_id"
							           :error-message="$errorMessage(errors, 'photo_id')"
							           :list="yesnoList"
							           list-value-field='name'
							           type="select"/>
						</div>

					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('fulltext_id') }}</label>
						<div class="col-7">
							
							<app-input v-model="detailsData.fulltext_id"
							           :error-message="$errorMessage(errors, 'fulltext_id')"
							           :list="yesnoList"
							           list-value-field='name'
							           type="select"/>
						</div>

					</div>
				</div>
				
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('table_id') }}</label>
						<div class="col-7">
							
							<app-input v-model="detailsData.table_id"
							           :error-message="$errorMessage(errors, 'table_id')"
							           :list="yesnoList"
							           list-value-field='name'
							           type="select"/>
						</div>

					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('science') }}</label>
						<div class="col-7">
							
							<app-input v-model="detailsData.science"
							           :error-message="$errorMessage(errors, 'science')"
							           :list="yesnoList"
							           list-value-field='name'
							           type="select"/>
						</div>

					</div>
				</div>
				
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('restorer_id') }}</label>
						<div class="col-7">
							
							<app-input v-model="detailsData.restorer_id"
							           :error-message="$errorMessage(errors, 'restorer_id')"
							           :list="restorerList"
							           list-value-field='name'
							           type="select"/>
						</div>

					</div>
				</div>
				
										 

				
			</div>

		</div>
		<app-fund-modal-info
		v-if="isFundModalActiveInfo"
		:infotitle="infotitle"
		:infobody="infobody"
      	@close-modal="closeModal"
    />
	</div>
</template>

<script>

import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {formatDateToLocal, urlGenerator} from "@app/Helpers/helpers";

export default {
	name: "DetailsInformationFund",
	mixins: [FormMixin],
	props: {
		detailsData: {
			type: Object,
			required: true
		},
		detailsSyncUrl: {
			type: String,
			required: true
		},
		blockEdit: {
			type: Boolean,
			required: true
		},
	},
	data() {
		return {
			urlGenerator,
			isFundModalActiveInfo: false,
			formatDateToLocal,
			isDetailsActive: true,
			formData: {},
			infotitle: 'title',
			infobody: 'body',
	
			errors: {}
		}
	},
	computed: {
		contfundTypeList() {
			return this.$store.getters.contfundType
		},
	
		
		
		
		
		
		zalList() {
			return this.$store.getters.getZal
		},
		invList() {
			return this.$store.getters.getInv
		},
		yesnoList() {
			return this.$store.getters.getYesno
		},
		restorerList() {
			return this.$store.getters.getRestorer
		},
		storageList() {
			return this.$store.getters.getInrest
		},
		
		
		peopleList() {
			return this.$store.getters.getPerson
		},
		organizationList() {
			return this.$store.getters.getOrganization
		},
	},
	methods: {
		openModal(title, body) {

      this.isFundModalActiveInfo = true;
	  this.infotitle = title;
	  this.infobody = body;
    },
	closeModal() {
      this.isFundModalActiveInfo = false;
	  this.infotitle = '';
	  this.infobody = '';
      $("#fund-modal-info").modal("hide");
    },
		detailsInfoSync() {

			this.formData.name = this.detailsData.name;
			this.formData.inrest_id = this.detailsData.inrest_id;
			
			this.formData.zal_id = this.detailsData.zal_id;
			this.formData.science = this.detailsData.science;
			this.formData.inv_id = this.detailsData.inv_id;
			this.formData.tago_id = this.detailsData.tago_id;
			this.formData.photo_id = this.detailsData.photo_id;
			this.formData.desc_id = this.detailsData.desc_id;
			this.formData.table_id = this.detailsData.table_id;
			this.formData.fulltext_id = this.detailsData.fulltext_id;
			this.formData.restorer_id = this.detailsData.restorer_id;
			
			
			this.formData.who = this.detailsData.who;
			this.formData.rest = this.detailsData.rest;
			this.formData.org = this.detailsData.org;
			
			
			this.formData.fund_type_id = this.detailsData.fund_type_id;
			this.formData.owner_id = this.detailsData.owner_id;
			this.submitFromFixin('patch', this.detailsSyncUrl, this.formData);
		},

		afterError(response) {
			this.errors = response.data.errors
		},

		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.isDetailsActive = true
			this.errors = {}
			this.$emit('update-request');
		},

		detailsInfoClose() {
			this.isDetailsActive = true;
			this.$emit('update-unblock');
		},
		detailsInfoEdit() {
			this.isDetailsActive = false;
			this.$emit('update-block');
		},
		getAllCountrys() {
			this.axiosGet(`crm/country`).then(({data}) => {
				this.countryList = data;
			});
		}
		
	},
	created() {
		this.$store.dispatch('contfundType');
		this.$store.dispatch('getOwner');
		
		this.$store.dispatch('getZal');
		this.$store.dispatch('getInv');
		this.$store.dispatch('getInrest');
		this.$store.dispatch('getYesno');
		this.$store.dispatch('getRestorer');
		
		
		this.$store.dispatch('getPerson');
		this.$store.dispatch('getOrganization');
		this.getAllCountrys();
	},
}
</script>

